import React from "react";
import ImageField from "./ImageField";

const AssetImageField = ({ entity, value, onClick }) => {
  return <ImageField onClick={() => onClick(entity.id)} entity={entity} value={value} />;
};

export default AssetImageField;
